module.exports = __webpack_public_path__ + "static/media/congratulation.bb5581ae.gif";